import { Col } from "reactstrap";
import { H4, LI, P, UL } from "../../../../AbstractElements";
import { AllAbout, Href } from "../../../../Constant";
import { SEARCH_TAB_DATA } from "../../../../Data/SearchResult";

const VideoTab2 = () => {
  return (
    <Col xxl="6">
      <H4 className="pb-4">{AllAbout}</H4>
      {SEARCH_TAB_DATA.slice(1, 4).map((item) => (
        <div className="d-flex info-block" key={item.id}>
          <iframe className="me-3" width="200" height="100" src={item.videoLink} title="vodeos"></iframe>
          <div className="flex-grow-1">
            <a href={Href}>{item.url}</a>
            <H4>{item.title}</H4>
            <P>{item.detail}</P>
            <div className="star-ratings">
              <UL className="search-info simple-list d-flex- flex-row">
                <LI>{item.star}</LI>
                <LI>{item.vote}</LI>
                <LI>{item.news}</LI>
              </UL>
            </div>
          </div>
        </div>
      ))}
    </Col>
  );
};

export default VideoTab2;
